<template>
  <div v-loading="loading" class="businessApplicationDetail">
    <div class="businessApplicationDetail-nr">
      <div class="businessApplicationDetails-first">
        <div class="businessApplicationDetails-word">基本信息</div>
        <div :v-model="businessApplicationVO" class="businessApplicationDetail-message">
          <table class="businessApplicationTable" style="width: 100%;">
            <tr>
              <td class="tableLabel">编号:</td>
              <td>{{businessApplicationVO.businessApplicationNO}}</td>
              <td class="tableLabel">状态:</td>
              <td style="width: 220px">
                {{constant.BusinessApplicationStatus[businessApplicationVO.status]}}
              </td>
              <td class="tableLabel">制单时间:</td>
              <td style="width: 220px">{{businessApplicationVO.createdDate}}</td>
            </tr>
          </table>
        </div>
      </div>
      <div class="businessApplicationDetails-second">
        <div class="businessApplicationDetails-seond-top">
          <div style="position: absolute;top: 0;left: 0;z-index: 99;width: 100%">
            <div class="businessApplicationDetails-word">价格申请</div>
          </div>
          <!--          <table cellspacing="0" class="table-pj">-->
          <!--            <tr>-->
          <!--              <td>汇总统计</td>-->
          <!--              <td>平均申请价毛利率</td>-->
          <!--              <td style="color: rgb(45, 140, 240)">{{businessApplicationVO.applicationAvgPercent}}%</td>-->
          <!--              <td>平均审核价毛利率</td>-->
          <!--              <td>-->
          <!--                <div>-->
          <!--                  营销中心：<span style="color: rgb(45, 140, 240)">{{businessApplicationVO.approve1AvgPercent}}%</span>-->
          <!--                </div>-->
          <!--                <div>-->
          <!--                  总监：<span style="color: rgb(45, 140, 240)">{{businessApplicationVO.approve2AvgPercent}}%</span>-->
          <!--                </div>-->
          <!--                <div>-->
          <!--                  财务总监：<span style="color: rgb(45, 140, 240)">{{businessApplicationVO.finApproveAvgPercent}}%</span>-->
          <!--                </div>-->
          <!--                <div>-->
          <!--                  总经理：<span style="color: rgb(45, 140, 240)">{{businessApplicationVO.approve3AvgPercent}}%</span>-->
          <!--                </div>-->
          <!--              </td>-->
          <!--            </tr>-->
          <!--          </table>-->
          <el-table
              :data="businessApplicationVO.applicationPriceWrapperS"
              default-expand-all
              style="width: 100%;">
            <el-table-column type="expand">
              <template slot-scope="props">
                <el-table
                    :data="props.row.paDetailVOS"
                    style="width: 90%;margin: 0 auto">
                  <el-table-column label="特性" prop="nameValues"/>
                  <el-table-column label="执行价" prop="executePrice">
                    <template slot-scope="scope">
                      <div v-if="scope.row.priceApplicationType === 20">
                        申请折扣
                      </div>
                      <div v-else>
                        <div v-if="scope.row.standardFloatingPrice === 0">
                          <div v-if="businessApplicationVO.costVisible === true">
                            {{"成本价:" + scope.row.costPrice}}
                          </div>
                          <div :style="businessApplicationVO.applicantPositon === 1?'font-weight: 500':'font-weight: bold'">
                            销售员:{{scope.row.level1Price}}
                          </div>
                          <div v-if="props.row.userPosition !== 1">
                            {{"区总:" + scope.row.level2Price}}
                          </div>
                          <div v-if="props.row.userPosition !== 1 && props.row.userPosition !== 2">
                            {{"总监:" + scope.row.level3Price}}
                          </div>
                        </div>
                        <div v-else>
                          <div v-if="businessApplicationVO.costVisible === true">
                            {{"成本价:"+scope.row.costPrice + '/' + scope.row.costFloatingPrice}}
                          </div>
                          <div :style="businessApplicationVO.applicantPositon === 1?'font-weight: 500':'font-weight: bold'">
                            销售员:{{scope.row.level1Price + '/' + scope.row.level1FloatingPrice}}
                          </div>
                          <div v-if="props.row.userPosition !== 1">
                            {{"区总:" + scope.row.level2Price + '/' + scope.row.level2FloatingPrice}}
                          </div>
                          <div v-if="props.row.userPosition !== 1 && props.row.userPosition !== 2">
                            {{"总监:" + scope.row.level3Price + '/' + scope.row.level3FloatingPrice}}
                          </div>
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="申请价格" prop="applicationPrice">
                    <template slot-scope="scope">
                      <div v-if="scope.row.priceApplicationType === 20">
                        <div v-if="scope.row.floatingPriceType === 20">
                          <div>线缆单价折扣:{{scope.row.price}}%</div>
                          <div>每层加工费:{{scope.row.floatingPrice}}</div>
                        </div>
                        <div v-else>
                          <div>线缆单价折扣:{{scope.row.price}}%</div>
                          <div>加工费折扣:{{scope.row.floatingPrice}}%</div>
                        </div>
                      </div>
                      <div v-else>
                        <div v-if="scope.row.floatingPrice === 0">
                          {{scope.row.price}}
                          <div v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                            <div>
                              毛利：
                              <span>
                                {{parseFloat((scope.row.price-scope.row.costPrice)/1.13).toFixed(2)}}
                              </span>
                            </div>
                            <div>
                              毛利率：
                              <span v-if="scope.row.price === 0">0</span>
                              <span v-else>
                                {{parseFloat(((scope.row.price-scope.row.costPrice)/scope.row.price)*100).toFixed(2)}}
                              </span>
                              %
                            </div>
                          </div>
                        </div>
                        <div v-else>
                          {{scope.row.price + "/" + scope.row.floatingPrice}}
                          <div v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                            <div>
                              毛利：
                              <span>
                                {{parseFloat((scope.row.price-scope.row.costPrice)/1.13).toFixed(2)}}
                              </span>
                            </div>
                            <div>
                              毛利率：
                              <span v-if="scope.row.price === 0">0</span>
                              <span v-else>
                                {{parseFloat(((scope.row.price-scope.row.costPrice)/scope.row.price)*100).toFixed(2)}}
                              </span>
                              %
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column width="350" label="审核价格" prop="mainRepairMan">
                    <template slot-scope="scope">
                      <!--申请折扣-->
                      <div v-if="scope.row.priceApplicationType === 20" style="display: flex;flex-direction: row">
                        <div style="width: 50%;text-align: center">
                          <div v-if="scope.row.price === scope.row.approve1Price">
                            营销中心:线缆: <span>{{scope.row.approve1Price}}%</span>
                          </div>
                          <div v-else>
                            营销中心:线缆: <span style="color: red">{{scope.row.approve1Price}}%</span>
                          </div>

                          <div v-if="scope.row.price === scope.row.approve2Price">
                            总监:线缆: <span>{{scope.row.approve2Price}}%</span>
                          </div>
                          <div v-else>
                            总监:线缆: <span style="color: red">{{scope.row.approve2Price}}%</span>
                          </div>

                          <div v-if="scope.row.price === scope.row.finApprovePrice">
                            财务总监:线缆: <span>{{scope.row.finApprovePrice}}%</span>
                          </div>
                          <div v-else>
                            财务总监:线缆:
                            <span style="color: red">
                              {{scope.row.finApprovePrice}}%
                            </span>
                          </div>

                          <div v-if="scope.row.price === scope.row.approve3Price">
                            总经理:线缆: <span>{{scope.row.approve3Price}}%</span>
                          </div>
                          <div v-else>
                            总经理:线缆: <span style="color: red">{{scope.row.approve3Price}}%</span>
                          </div>
                        </div>
                        <div style="width: 50%;text-align: center">
                          <div v-if="scope.row.floatingPrice === scope.row.approve1FloatingPrice">
                            <div v-if="scope.row.floatingPriceType === 20">
                              每层加工费: <span>{{scope.row.approve1FloatingPrice}}</span>
                            </div>
                            <div v-else>
                              加工费折扣: <span>{{scope.row.approve1FloatingPrice}}%</span>
                            </div>
                          </div>
                          <div v-else>
                            <div v-if="scope.row.floatingPriceType === 20">
                              每层加工费: <span style="color: red">{{scope.row.approve1FloatingPrice}}</span>
                            </div>
                            <div v-else>
                              加工费折扣: <span style="color: red">{{scope.row.approve1FloatingPrice}}%</span>
                            </div>
                          </div>

                          <div v-if="scope.row.floatingPrice === scope.row.approve2FloatingPrice">
                            <div v-if="scope.row.floatingPriceType === 20">
                              每层加工费: <span>{{scope.row.approve2FloatingPrice}}</span>
                            </div>
                            <div v-else>
                              加工费折扣: <span>{{scope.row.approve2FloatingPrice}}%</span>
                            </div>
                          </div>
                          <div v-else>
                            <div v-if="scope.row.floatingPriceType === 20">
                              每层加工费: <span style="color: red">{{scope.row.approve2FloatingPrice}}</span>
                            </div>
                            <div v-else>
                              加工费折扣: <span style="color: red">{{scope.row.approve2FloatingPrice}}%</span>
                            </div>
                          </div>

                          <div v-if="scope.row.floatingPrice === scope.row.finApproveFloatingPrice">
                            <div v-if="scope.row.floatingPriceType === 20">
                              每层加工费: <span>{{scope.row.finApproveFloatingPrice}}</span>
                            </div>
                            <div v-else>
                              加工费折扣: <span>{{scope.row.finApproveFloatingPrice}}%</span>
                            </div>
                          </div>
                          <div v-else>
                            <div v-if="scope.row.floatingPriceType === 20">
                              每层加工费: <span style="color: red">{{scope.row.finApproveFloatingPrice}}</span>
                            </div>
                            <div v-else>
                              加工费折扣: <span style="color: red">{{scope.row.finApproveFloatingPrice}}%</span>
                            </div>
                          </div>

                          <div v-if="scope.row.floatingPrice === scope.row.approve3FloatingPrice">
                            <div v-if="scope.row.floatingPriceType === 20">
                              每层加工费: <span>{{scope.row.approve3FloatingPrice}}</span>
                            </div>
                            <div v-else>
                              加工费折扣: <span>{{scope.row.approve3FloatingPrice}}%</span>
                            </div>
                          </div>
                          <div v-else>
                            <div v-if="scope.row.floatingPriceType === 20">
                              每层加工费: <span style="color: red">{{scope.row.approve3FloatingPrice}}</span>
                            </div>
                            <div v-else>
                              加工费折扣: <span style="color: red">{{scope.row.approve3FloatingPrice}}%</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-else>
                        <div v-if="scope.row.floatingPrice === 0">
                          <div v-if="scope.row.price === scope.row.approve1Price">
                            营销中心:
                            <span>{{scope.row.approve1Price}}</span>
                            <span v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                              /毛利：
                              <span>
                                {{parseFloat((scope.row.approve1Price-scope.row.costPrice)/1.13).toFixed(2)}}%,
                              </span>
                              毛利率：
                              <span v-if="scope.row.approve1Price === 0">0</span>
                              <span v-else>
                                {{parseFloat(((scope.row.approve1Price-scope.row.costPrice)/scope.row.approve1Price)*100).toFixed(2)}}%
                              </span>
                            </span>
                          </div>
                          <div v-else>
                            营销中心:
                            <span style="color: red">{{scope.row.approve1Price}}</span>
                            <span v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                              /毛利：
                              <span>
                                {{parseFloat((scope.row.approve1Price-scope.row.costPrice)/1.13).toFixed(2)}},
                              </span>
                              毛利率：
                              <span v-if="scope.row.approve1Price === 0">0</span>
                              <span v-else>
                                {{parseFloat(((scope.row.approve1Price-scope.row.costPrice)/scope.row.approve1Price)*100).toFixed(2)}}
                              </span>
                              %
                            </span>
                          </div>
                          <div v-if="scope.row.price === scope.row.approve2Price">
                            总监:
                            <span>{{scope.row.approve2Price}}</span>
                            <span v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                              /毛利：
                              <span>
                                {{parseFloat((scope.row.approve2Price-scope.row.costPrice)/1.13).toFixed(2)}},
                              </span>
                              毛利率：
                              <span v-if="scope.row.approve2Price === 0">0</span>
                              <span v-else>
                                {{parseFloat(((scope.row.approve2Price-scope.row.costPrice)/scope.row.approve2Price)*100).toFixed(2)}}
                              </span>
                              %
                            </span>
                          </div>
                          <div v-else>
                            总监:
                            <span style="color: red">{{scope.row.approve2Price}}</span>
                            <span v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                              /毛利：
                              <span>
                                {{parseFloat((scope.row.approve2Price-scope.row.costPrice)/1.13).toFixed(2)}},
                              </span>
                              毛利率：
                              <span v-if="scope.row.approve2Price === 0">0</span>
                              <span v-else>
                                {{parseFloat(((scope.row.approve2Price-scope.row.costPrice)/scope.row.approve2Price)*100).toFixed(2)}}
                              </span>
                              %
                            </span>
                          </div>
                          <div v-if="scope.row.price === scope.row.finApprovePrice">
                            财务总监:
                            <span>{{scope.row.finApprovePrice}}</span>
                            <span v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                              /毛利：
                              <span>
                                {{parseFloat((scope.row.finApprovePrice-scope.row.costPrice)/1.13).toFixed(2)}},
                              </span>
                              毛利率：
                              <span v-if="scope.row.finApprovePrice === 0">0</span>
                              <span v-else>
                                {{parseFloat(((scope.row.finApprovePrice-scope.row.costPrice)/scope.row.finApprovePrice)*100).toFixed(2)}}
                              </span>
                              %
                            </span>
                          </div>
                          <div v-else>
                            财务总监:
                            <span style="color: red">{{scope.row.finApprovePrice}}</span>
                            <span v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                              /毛利：
                              <span>
                                {{parseFloat((scope.row.finApprovePrice-scope.row.costPrice)/1.13).toFixed(2)}},
                              </span>
                              毛利率：
                              <span v-if="scope.row.finApprovePrice === 0">0</span>
                              <span v-else>
                                {{parseFloat(((scope.row.finApprovePrice-scope.row.costPrice)/scope.row.finApprovePrice)*100).toFixed(2)}}
                              </span>
                              %
                            </span>
                          </div>
                          <div v-if="scope.row.price === scope.row.approve3Price">
                            总经理:
                            <span>{{scope.row.approve3Price}}</span>
                            <span v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                              /毛利：
                              <span>
                                {{parseFloat((scope.row.approve3Price-scope.row.costPrice)/1.13).toFixed(2)}},
                              </span>
                              毛利率：
                              <span v-if="scope.row.approve3Price === 0">0</span>
                              <span v-else>
                                {{parseFloat(((scope.row.approve3Price-scope.row.costPrice)/scope.row.approve3Price)*100).toFixed(2)}}
                              </span>
                              %
                            </span>
                          </div>
                          <div v-else>
                            总经理:
                            <span style="color: red">{{scope.row.approve3Price}}</span>
                            <span v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                              /毛利：
                              <span>
                                {{parseFloat((scope.row.approve3Price-scope.row.costPrice)/1.13).toFixed(2)}},
                              </span>
                              毛利率：
                              <span v-if="scope.row.approve3Price === 0">0</span>
                              <span v-else>
                                {{parseFloat(((scope.row.approve3Price-scope.row.costPrice)/scope.row.approve3Price)*100).toFixed(2)}}
                              </span>
                              %
                            </span>
                          </div>
                        </div>

                        <div v-else>
                          <div v-if="scope.row.price === scope.row.approve1Price">
                            营销中心
                            <span>
                              {{scope.row.approve1Price + "/" + scope.row.approve1FloatingPrice}}
                            </span>
                            <span v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                              /毛利：
                              <span>
                                {{parseFloat((scope.row.approve1Price-scope.row.costPrice)/1.13).toFixed(2)}},
                              </span>
                              毛利率：
                              <span v-if="scope.row.approve1Price === 0">0</span>
                              <span v-else>
                                {{parseFloat(((scope.row.approve1Price-scope.row.costPrice)/scope.row.approve1Price)*100).toFixed(2)}}
                              </span>
                              %
                            </span>
                          </div>
                          <div v-else>
                            营销中心
                            <span style="color: red">
                              {{scope.row.approve1Price + "/" + scope.row.approve1FloatingPrice}}
                            </span>
                            <span v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                              /毛利：
                              <span>
                                {{parseFloat((scope.row.approve1Price-scope.row.costPrice)/1.13).toFixed(2)}},
                              </span>
                              毛利率：
                              <span v-if="scope.row.approve1Price === 0">0</span>
                              <span v-else>
                                {{parseFloat(((scope.row.approve1Price-scope.row.costPrice)/scope.row.approve1Price)*100).toFixed(2)}}
                              </span>
                              %
                            </span>
                          </div>

                          <div v-if="scope.row.price === scope.row.approve2Price">
                            总监:
                            <span>
                              {{scope.row.approve2Price + '/' +scope.row.approve2FloatingPrice}}
                            </span>
                            <span v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                              /毛利：
                              <span>
                                {{parseFloat((scope.row.approve2Price-scope.row.costPrice)/1.13).toFixed(2)}},
                              </span>
                              毛利率：
                              <span v-if="scope.row.approve2Price === 0">0</span>
                              <span v-else>
                                {{parseFloat(((scope.row.approve2Price-scope.row.costPrice)/scope.row.approve2Price)*100).toFixed(2)}}
                              </span>
                              %
                            </span>
                          </div>
                          <div v-else>
                            总监:
                            <span style="color: red">
                              {{scope.row.approve2Price + '/' +scope.row.approve2FloatingPrice}}
                            </span>
                            <span v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                              /毛利：
                              <span>
                                {{parseFloat((scope.row.approve2Price-scope.row.costPrice)/1.13).toFixed(2)}},
                              </span>
                              毛利率：
                              <span v-if="scope.row.approve2Price === 0">0</span>
                              <span v-else>
                                {{parseFloat(((scope.row.approve2Price-scope.row.costPrice)/scope.row.approve2Price)*100).toFixed(2)}}
                              </span>
                              %
                            </span>
                          </div>

                          <div v-if="scope.row.price === scope.row.finApprovePrice">
                            财务总监:
                            <span>
                              {{scope.row.finApprovePrice + '/' +scope.row.finApproveFloatingPrice}}
                            </span>
                            <span v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                              /毛利：
                              <span>
                                {{parseFloat((scope.row.finApprovePrice-scope.row.costPrice)/1.13).toFixed(2)}},
                              </span>
                              毛利率：
                              <span v-if="scope.row.finApprovePrice === 0">0</span>
                              <span v-else>
                                {{parseFloat(((scope.row.finApprovePrice-scope.row.costPrice)/scope.row.finApprovePrice)*100).toFixed(2)}}
                              </span>
                              %
                            </span>
                          </div>
                          <div v-else>
                            财务总监:
                            <span style="color: red">
                              {{scope.row.finApprovePrice + '/' +scope.row.finApproveFloatingPrice}}
                            </span>
                            <span v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                              /毛利：
                              <span>
                                {{parseFloat((scope.row.finApprovePrice-scope.row.costPrice)/1.13).toFixed(2)}},
                              </span>
                              毛利率：
                              <span v-if="scope.row.finApprovePrice === 0">0</span>
                              <span v-else>
                                {{parseFloat(((scope.row.finApprovePrice-scope.row.costPrice)/scope.row.finApprovePrice)*100).toFixed(2)}}
                              </span>
                              %
                            </span>
                          </div>

                          <div v-if="scope.row.price === scope.row.approve3Price">
                            总经理:
                            <span>
                              {{scope.row.approve3Price + "/" + scope.row.approve3FloatingPrice}}
                            </span>
                            <span v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                              /毛利：
                              <span>
                                {{parseFloat((scope.row.approve3Price-scope.row.costPrice)/1.13).toFixed(2)}},
                              </span>
                              毛利率：
                              <span v-if="scope.row.approve3Price === 0">0</span>
                              <span v-else>
                                {{parseFloat(((scope.row.approve3Price-scope.row.costPrice)/scope.row.approve3Price)*100).toFixed(2)}}
                              </span>
                              %
                            </span>
                          </div>
                          <div v-else>
                            总经理:
                            <span style="color: red">
                              {{scope.row.approve3Price + "/" + scope.row.approve3FloatingPrice}}
                            </span>
                            <span v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                              /毛利：
                              <span>
                                {{parseFloat((scope.row.approve3Price-scope.row.costPrice)/1.13).toFixed(2)}},
                              </span>
                              毛利率：
                              <span v-if="scope.row.approve3Price === 0">0</span>
                              <span v-else>
                                {{parseFloat(((scope.row.approve3Price-scope.row.costPrice)/scope.row.approve3Price)*100).toFixed(2)}}
                              </span>
                              %
                            </span>
                          </div>
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                  <!--<el-table-column label="备注" prop="note"/>-->
                </el-table>
              </template>
            </el-table-column>
            <el-table-column prop="productName">
              <template slot-scope="scope">
                <span style="font-weight: bold">{{scope.row.productName}}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <handle-detail :bill-id="billId" :bill-type="billType" sequ-id="-1"/>
    </div>
  </div>
</template>

<script>
  import constant from "../../../util/constant";
  import HandleDetail from "@/views/workFlow/HandleDetail";

  export default {
    name:"BusinessApplicationPriceApplyPreview",
    components: {HandleDetail},
    data() {

      return {
        dialogVisible: false,
        loading: false,
        constant,
        businessApplicationVO: {},
        isHidden: false,
        expands: [],
        id: "",
        billId: "0",
        billType: "0",
        ruleValidate: {
          orderNo: {required: true, message: "不能为空", trigger: "blur"},
        },
      };
    },
    created() {
      this.id = this.$route.query.businessApplicationID;
      this.billId = this.$route.query.businessApplicationID + "";
      this.billType = this.$route.query.billType + "";
      this.getData();
      this.expands.push(1);
    },
    methods: {
      getData() {
        this.loading = true;
        this.$http
          .get("basic", `sd/ba/getPriceApply/${this.id}/${0}`)
          .then(resp => {
            console.log(resp);
            this.loading = false;
            this.businessApplicationVO = resp;
          });
      },
    },
  };
</script>

<style lang="scss">
  .businessApplicationDetail{
    width: 97%;
    margin: 10px auto;
    .businessApplicationDetail-nr{
      .businessApplicationDetails-word{
        padding: 10px 25px;
        font-size: 14px;
        background: #f4f7fa;
        border-bottom: 1px solid #dddddd;
      }

      .businessApplicationDetails-first{
        border: 1px solid #dddddd;
        .businessApplicationDetail-message {
          padding: 10px;
          table.businessApplicationTable {
            font-family: verdana,arial,sans-serif;
            font-size:11px;
            color:#333333;
            border-width: 1px;
            border-color: #dddddd;
            border-collapse: collapse;
          }
          table.businessApplicationTable th {
            text-align: left;
            border-width: 1px;
            padding: 8px;
            border-style: solid;
            border-color: #dddddd;
            background-color: #f4f7fa;
          }
          table.businessApplicationTable td {
            border-width: 1px;
            padding: 8px;
            border-style: solid;
            border-color: #dddddd;
          }
          .tableLabel {
            width: 10%;
            text-align: right;
            background-color: #f4f7fa;
          }
        }
      }
      .businessApplicationDetails-second{
        position: relative;
        margin-top: 1%;
        border: 1px solid #dddddd;
        .table-pj{
          width: 100%;
          background: #ffffff;
          position: absolute;
          top: 0;
          left: 0;
          z-index: 100;
          margin-top: 35px!important;
          border-top: 1px solid #ebebeb;
          tr{
            td:first-child{
              border-left: none;
            }
            td{
              border-left: 1px solid #ebebeb;
              font-size: 12px;
              text-align: center;
              padding: 5px 0;
              div{
                width: 40%;
                margin: 0 auto 5px auto;
                text-align: left;
              }
              div:last-child{
                margin-bottom: 0;
              }
            }
          }
        }
        .historyBtn{
          button{
            border: none;
            background: #f4f7fa;
            padding: 0;
            margin: 0;
            i{
              color: #2D8CF0;
            }
          }
        }
      }
    }
    .el-table th{
      background: #D1E6F5;
      height: 34px;
    }
    .el-table th.is-leaf, .el-table td{
      padding: 5px 0;
    }
    .el-table__header, .el-table__body, .el-table__footer{
      width: 100%!important;
    }
    @media (min-width: 1300px) and (max-width: 1440px) {
      .businessApplicationDetail {
        width: 1440px;
      }
    }
  }
</style>
